<template>
  <transition name="slide-fade">
    <div v-if="visible" class="loading-scene">
      <img :src="`${baseUrl}frontend-assets/img/logo-x-white.png`" class="loading-logo">
      <div class="loading-progress-bar nostripes">
        <span :style="`width: ${precent}%`"></span>
      </div>
    </div>
  </transition>
</template>

<script>
// 进度到达 100% 后，保留一小段时间让用户看到完整进度条再收起
const HIDE_DELAY = 600;

export default {
  name: 'LoadingScene',
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      visible: true,
      hideTimer: null,
    };
  },
  computed: {
    precent() {
      return this.$store.state.loadingScene.precent;
    },
  },
  watch: {
    // 进度并不总是单调递增（切换语言时可能先被页面上报到 100，随后路由守卫又回退到 20/40），
    // 所以这里每次都先清掉上一个待执行的隐藏任务再决定显隐，
    // 避免遗留定时器在之后「二次隐藏」，把正在进行的 enter/leave 过渡打断。
    precent: {
      immediate: true,
      handler(val) {
        clearTimeout(this.hideTimer);
        if (val >= 100) {
          this.hideTimer = setTimeout(() => {
            this.visible = false;
          }, HIDE_DELAY);
        } else {
          this.visible = true;
        }
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this.hideTimer);
  },
};
</script>

<style scoped lang="less">
.slide-fade-enter-active {
  transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.slide-fade-leave-active {
  transition: all 1s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(100%);
  // opacity: 0;
}
</style>
